import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { withWidth } from '@material-ui/core'
import { withStyles } from '@material-ui/core';
import withTranslations from '../../translations';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { setCurrentIndex } from '../../actions/actionMode';
import {  deleteImages, setAdditionalImages } from '../../actions/form';

import {
  Button,
  ConfirmationDialog,
  DialogContentText,
  FabButton,
  Grid,
  Typography,
} from '../base';

import ActionModeQuestion from './ActionModeQuestion/ActionModeQuestion';

import {
  dashToCamelCase,
  flattenArray,
} from '../../utils/utils';

import { titleHeight } from './constants';

import {
  additionalFilesKey,
} from '../../constants/uploadFiles';

const allowedQuestionTypes = [
  'select',
  'multiselect',
  'file',
];

const styles = theme => ({
  actionModeOverlay: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1500,
    background: 'white',
  },
  rotateMessageContainer: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    background: 'white',
    paddingTop: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  rotateMessage: {
    marginBottom: theme.spacing(4),
  },
  actionModeMainContainer: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    height: '100vh',
    padding: 0,
    width: '100%',
  },
  titleContainer: {
    height: titleHeight,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100vw',
    marginLeft: '-27%',
    fontSize: 18,

    [theme.breakpoints.up('sm')]: {
      maxWidth: '80%',
      marginLeft: '10%',
      fontSize: 22,
    },
  },
  main: {
    height: '100vh',
    flex: 1,
    alignSelf: 'flex-start',
    padding: theme.spacing(0, 4),
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(0, 1),
    },
  },
  content: {
    flex: 1,
  },
  questionInfo: {
    height: theme.spacing(9),
  },
  closeButton: {
    background: theme.palette.error.light,
    color: 'white',
    position: 'absolute',
    right: theme.spacing(2),
    bottom: theme.spacing(2),
    fontSize: 10,

    [theme.breakpoints.up(700)]: {
      fontSize: 20,
    },

    '&:hover': {
      background: theme.palette.error.light,
    },
  },
  saveActionModeButton: {
    background: theme.palette.error.light,
    color: 'white',
    position: 'absolute',
    left: theme.spacing(2),
    bottom: theme.spacing(2),
    fontSize: 10,

    [theme.breakpoints.up(700)]: {
      right: theme.spacing(15),
      fontSize: 20,
    },

    '&:hover': {
      background: theme.palette.error.light,
    },
  },
  actionContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  lastScreenContainer: {
    textAlign: 'center',
    fontSize: 24,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '90%',

    '& button': {
      background: theme.palette.error.light,
      color: 'white',
      fontSize: 24,
      padding: theme.spacing(2, 3),

      [theme.breakpoints.up('md')]: {
        fontSize: 30,
      },

      '&:hover': {
        background: theme.palette.error.light,
      },
    }
  },
  saveButton: {
    background: `${theme.palette.secondary.main} !important`,
    fontSize: 40,
  },
  navigationButton: {
    color: 'white',
    background: theme.palette.error.light,
    width: theme.spacing(13),
    height: theme.spacing(13),
    fontSize: 70,
    display: 'flex',

    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(10),
      height:  theme.spacing(10),
      fontSize: 50,
    },

    '& span': {
      lineHeight: 1,
      letterSpacing: 0,
    },

    '&:hover': {
      background: theme.palette.error.light,
    },
  },
});

const modalRoot = document.getElementById('portal-for-ActionMode');

class ActionMode extends Component {
  state = {
    questions: [],
    isReady: false,
    fields: [],
    unsavedAnswersDialog: false,
    answers: null,
  };

  modal = document.createElement('div');

  componentDidMount() {
    modalRoot.appendChild(this.modal);
    document.body.addEventListener('ontouchend', e => e.preventDefault());
    document.body.style.overflow = 'hidden';

    const preparedQuestions = this.prepareQuestions(this.props.data);
    const preparedAllQuestions = this.prepareQuestionsWithHiddens(this.props.data);

    this.props.actions.deleteImages();

    this.setState(
      { questions: preparedQuestions, fields: preparedAllQuestions, answers: JSON.parse(JSON.stringify(this.props.answers)) },
      () => this.props.currentIndex < 0 ? this.props.actions.setCurrentIndex(0) : null,
      () => this.setState({isReady: true})
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { isReady, questions } = this.state;
    const { data, currentIndex } = this.props;

    if (isReady && !questions.length) {
      const preparedQuestions = this.prepareQuestions(data);

      this.setState(
        { questions: preparedQuestions, },
        () => this.props.actions.setCurrentIndex(currentIndex + 1)
      );
    }
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.modal);
    document.body.style.overflow = 'auto';
    document.body.removeEventListener('ontouchend', e => e.preventDefault());
    this.setState({questions: []});
  }

  handleBack = () => {
    const { currentIndex } = this.props;

    this.props.actions.setCurrentIndex(currentIndex - 1);
  }

  // Check if question is relevant and is of required type
  isQuestionForActionMode = q =>
    !q.shouldHide && allowedQuestionTypes.includes(q.type) && this.isImageUpload(q)

  isQuestionForActionModeWithHiddens = q =>
    allowedQuestionTypes.includes(q.type) && this.isImageUpload(q)

  isImageUpload = q => q.type === 'file' ? q.control && q.control.includes('image') : true

  prepareQuestions = data =>
    flattenArray(data
      .filter(ss => !ss.shouldHide && ss.fields.length > 0)
      .map(ss => ss.fields)
    ).filter(this.isQuestionForActionMode)

  prepareQuestionsWithHiddens = data =>
    flattenArray(data
      .filter(ss => ss.fields.length > 0)
      .map(ss => ss.fields)
    ).filter(this.isQuestionForActionModeWithHiddens)

  handleAlertDialogClose = async () => {
    await this.handleBack();
    this.setState({ unsavedAnswersDialog: false });
    this.props.handleClose();
    this.props.setAnswers(this.props.oldAnswers);
    document.body.style.overflow = 'auto';
    this.props.actions.setCurrentIndex(-1);
    this.props.actions.deleteImages();
    this.props.actions.setAdditionalImages([]);
    this.props.updateChangedForms([]);
    sessionStorage.removeItem('questionAnswerSession');
  }

  handleAlertDialogConfirm = async () => {
    await this.props.handleClose();
    this.handleBack();
    this.setState({ unsavedAnswersDialog: false });
    this.props.onFormSubmit();
    this.props.actions.deleteImages();
    this.props.actions.setAdditionalImages([]);
    document.body.style.overflow = 'auto';
    this.props.actions.setCurrentIndex(-1);
  }

  renderAlertDialog = (c, t, gt) =>
    <ConfirmationDialog
      style={{zIndex: 1501}}
      open={this.state.unsavedAnswersDialog}
      title={gt.confirmationDialogTitle}
      cancelButtonText={gt.cancel}
      onClose={() => this.setState({ unsavedAnswersDialog: false})}
      confirmButtonText={gt.confirm}
      handleCancel={() => this.handleAlertDialogClose()}
      handleConfirm={() => this.handleAlertDialogConfirm()}
    >
      <DialogContentText>{gt.unsavedAnswersActionMode}</DialogContentText>
    </ConfirmationDialog>

  onSaveActionModeClick = () => {
    this.props.onFormSubmit();
    this.props.actions.deleteImages();
    this.props.actions.setAdditionalImages([]);
  }

  onCloseButtonClick = async () => {
    if (this.props.changedFields.length) {
      this.setState({ unsavedAnswersDialog: true });
    } else {
      await this.handleBack();
      this.props.actions.deleteImages();
      this.props.actions.setAdditionalImages([]);
      this.props.handleClose();
      this.props.actions.setCurrentIndex(-1);
    }
  }

  renderSaveActionModeButton = () => {
    const {
      classes: c,
      gt,
      filesToUpload,
      changedFields,
      isSubmitting
    } = this.props;

    return (
      <Button
        variant='contained'
        disabled={!changedFields.length || !!filesToUpload || isSubmitting} 
        onClick={this.onSaveActionModeClick}
        className={c.saveActionModeButton}
      >
        {
          isSubmitting
            ? gt.savingInProgress
            : gt.save
        }
      </Button>
    )
  }

  renderCloseButton = () => {
    const { classes: c, gt, filesToUpload, isSubmitting } = this.props;

    return <Button variant='contained' disabled={!!filesToUpload || isSubmitting} onClick={this.onCloseButtonClick} className={c.closeButton}>{gt.close}</Button>
  }

  renderTitle = (title, c, t, gt) =>
    <header className={c.titleContainer}>
      {t[dashToCamelCase(title)]}
    </header>

  handleNext = async e => {
    const { changedFields, currentIndex } = this.props;

    if (changedFields.length) {
      this.setState({questions: this.state.fields.filter(field => this.isQuestionForActionMode(field))});
    }

    this.props.actions.setCurrentIndex(currentIndex + 1);
  }

  renderRotateMessage = () => {
    const { classes: c, gt } = this.props;
    const isLandscape = window.screen.width > window.screen.height;
    const isXS = this.props.width === 'xs';

    return (
      !isLandscape && isXS &&
      <div className={c.rotateMessageContainer}>
        <Typography variant='h6' className={c.rotateMessage}>{gt.Errors.rotateDevice}</Typography>
        {this.renderCloseButton()}
      </div>
    )
  }

  renderLastScreenMessage = () => {
    const { classes: c, t, gt, changedFields } = this.props;

    return (
      <div className={c.lastScreenContainer}>
        {!changedFields.length ?
          <Fragment>
            <p>{t.lastScreenMessage}</p>
            <Button variant='contained' onClick={this.onCloseButtonClick} >{gt.close}</Button>
          </Fragment>
        : <Fragment>
            <p>{t.lastScreenMessageUnsavedAnswers}</p>
            <Button variant='contained' className={c.saveButton} onClick={this.handleAlertDialogConfirm}>{gt.save}</Button>
          </Fragment>
        }
      </div>
    )
  }

  renderActionMode = () => {
    const {
      classes: c,
      t,
      gt,
      formTranslations,
      title,
      handleFieldChange,
      filesToUpload,
      currentIndex,
      uploadEndpoint,
      rotateImageEndpoint,
      answers,
      jobId,
    } = this.props;
    
    const { questions } = this.state;
    const additionalFilesField = questions.find(q => q.key === additionalFilesKey(q.key));

    return (
      <div className={c.actionModeOverlay}>
        <Grid container className={c.actionModeMainContainer}>
          <Grid item xs={2} className={c.actionContainer}>
            <FabButton className={c.navigationButton} disabled={currentIndex === 0 || !!filesToUpload} onClick={this.handleBack}>
              {'<'}
            </FabButton>
          </Grid>
          <Grid item xs={8} component='main' className={c.main}>
            {this.renderTitle(title, c, formTranslations, gt)}
            <Grid item xs={12}>
              {questions && questions[currentIndex] && currentIndex < questions.length
                ? <Fragment>
                    <ActionModeQuestion
                      jobId={jobId}
                      question={questions[currentIndex]}
                      saveAnswer={handleFieldChange}
                      uploadEndpoint={uploadEndpoint}
                      rotateImageEndpoint={rotateImageEndpoint}
                      additionalFilesField={additionalFilesField}
                      t={t}
                      answers={answers}
                      setSAPCauseCodes={this.props.setSAPCauseCodes}
                    />
                    {this.renderSaveActionModeButton()}
                    {this.renderCloseButton()}
                  </Fragment>
                : this.renderLastScreenMessage()
              }
            </Grid>
          </Grid>
          <Grid item xs={2} className={c.actionContainer}>
            <FabButton disabled={currentIndex === questions.length || !!filesToUpload} onClick={this.handleNext} className={c.navigationButton}>
              {'>'}
            </FabButton>
          </Grid>
        </Grid>
        {this.renderRotateMessage()}
        {this.renderAlertDialog(c, t, gt)}
      </div>
    )
  }

  render() {
    return ReactDOM.createPortal(
      this.renderActionMode(),
      this.modal
    )
  }
};

const mapStateToProps = state => ({
  currentIndex: state.actionMode.currentIndex,
  filesToUpload: state.form.filesToUpload,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    setCurrentIndex: bindActionCreators(setCurrentIndex, dispatch),
    deleteImages: bindActionCreators(deleteImages, dispatch),
    setAdditionalImages: bindActionCreators(setAdditionalImages, dispatch),
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withWidth()(withTranslations(ActionMode, 'ActionMode'))));



// WEBPACK FOOTER //
// ./src/components/ActionMode/ActionMode.js